<script>
  import { File, isDev, kbFix, imgSrc } from '$client';
  export let data;
  export let type = 'integrated';

  const createFile = () => ({
    id: Math.random() * 999,
    attributes: { size: 1254.23, name: 'test.docx', url: '/' },
  });

  const createFaq = () => ({
    header: 'Вопрос',
    content: 'ответ',
    files: { data: Array(20).fill({}).map(createFile) },
  });

  $: if (!data && isDev()) data = { header: 'Часто задаваемый вопросы', data: Array(8).fill(1).map(createFaq) };

  const header = i => ({
    next: () => header(i + 1),
    get: className => `<h${i} itemprop="name" class="${className}">$</h${i}>`,
  });

  $: sectionHeader = header(Number(type === 'integrated') + 1);
  $: faqHeader = sectionHeader.next();
  $: fileHeader = faqHeader.next();
  $: itemprop = type === 'integrated' ? {} : { itemprop: 'mainEntity' };
</script>

{#if data}
  <section class="container faq">
    {@html sectionHeader.get('faq-section-header ' + (type === 'integrated' ? 'h2' : 'h1')).replace('$', data.header)}
    <ul>
      {#each data.data as faq}
        <li>
          <details {...itemprop} itemscope itemtype="http://schema.org/Question">
            <summary>
              {@html faqHeader.get('faq-summary-header').replace('$', faq.header)}
              <span>
                <span />
                <span />
              </span>
            </summary>
            <div
              itemprop="suggestedAnswer acceptedAnswer"
              itemscope
              itemtype="https://schema.org/Answer"
              class="faq-content custom-page">
              <div itemprop="text">
                {@html faq.content}
              </div>
            </div>
            {#if faq.files?.data?.length}
              <div class="faq-files">
                {#each faq.files.data as file (file.id)}
                  <a href={imgSrc(file.attributes.url)} target="_blank" rel="nofollow" download>
                    <File title={file.attributes.ext ?? file.attributes.name.split('.')[-1]} />
                    <div>
                      {@html fileHeader.get('faq-file-header').replace('$', file.attributes.name)}
                      <p>
                        {kbFix(file.attributes.size)}
                        {file.attributes.size / 1024 >= 1 ? 'МБ' : 'КБ'}
                      </p>
                    </div>
                  </a>
                {/each}
              </div>
            {/if}
          </details>
        </li>
      {/each}
    </ul>
  </section>
{/if}

<style lang="scss">
  div {
    width: 100%;
    overflow: hidden;
    color: #2c333cd9;
    font-size: 16px;
    font-family: Roboto;
    line-height: 140%;

    @media only screen and (max-width: 767.98px) {
      font-size: 14px;
    }
  }

  .faq-content {
    padding-bottom: 24px;
    margin-block: 0;
  }

  .faq-files {
    // align-items: stretch;
    // justify-items: stretch;
    display: inline-flex;
    flex-wrap: wrap;
    // display: inline-grid;
    // grid-auto-flow: dense;
    grid-template-rows: auto;
    // grid-template-columns: repeat(3, 1fr);
    gap: 40px;
    padding-bottom: 24px;

    > a {
      display: inline-flex;
      gap: 16px;
      align-items: center;

      > div {
        gap: 4px;
      }
    }

    p {
      color: #77818f;
      font-size: 16px;
      font-family: Roboto;
    }

    @media only screen and (max-width: 1250px) {
      grid-gap: 20px;
      grid-template-columns: repeat(2, 1fr);
    }

    @media only screen and (max-width: 767.98px) {
      grid-gap: 15px;

      p {
        font-size: 14px;
      }

      a {
        gap: 8px;
      }

      :global(svg) {
        width: 32px;
        height: 42px;
      }
    }

    @media only screen and (max-width: 550.98px) {
      grid-gap: 26px;
      grid-template-columns: repeat(1, 1fr);
    }
  }

  :global(.faq-section-header) {
    margin-bottom: 40px;
    color: #2c333c;
    font-weight: 800;
    font-family: Vela Sans;
  }

  :global(.faq-summary-header) {
    color: #2c333c;
    font-weight: bold;
    font-size: 20px;
    font-family: Vela Sans;
    text-align: start;

    @media only screen and (max-width: 767.98px) {
      font-size: 16px;
    }
  }

  :global(.faq-file-header) {
    color: rgb(44 51 60 / 85%);
    font-size: 16px;
    font-family: Roboto;
    line-height: 140%;
    word-wrap: break-word;

    @media only screen and (max-width: 767.98px) {
      font-size: 14px;
    }
  }

  li {
    border-top: 2px #dadada solid;
    cursor: pointer;

    &:last-child {
      border-bottom: 2px #dadada solid;
    }
  }

  summary {
    display: inline-flex;
    gap: 24px;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    padding-block: 24px;

    > span {
      position: relative;
      display: flex;
      align-items: center;
      justify-content: center;
      min-width: 18px;
      min-height: 18px;
      margin-right: 22px;
      transition: 0.25s;

      &::before {
        position: absolute;
        width: 0;
        height: 0;
        background: #22eaac;
        transition: 0.25s;
        content: '';
      }

      > span {
        position: absolute;
        min-width: 2px;
        height: 100%;
        background: #2c333c;
      }

      > span:last-child {
        transform: rotate(90deg);
      }
    }

    &:hover {
      > span {
        transform: rotate(22.5deg);

        &::before {
          width: calc(100% + 10px);
          height: calc(100% + 10px);
          border-radius: 50%;
        }
      }
    }
  }

  details[open] {
    > summary > span {
      transform: rotate(45deg);

      &::before {
        width: calc(100% + 10px);
        height: calc(100% + 10px);
        border-radius: 50%;
      }
    }
  }
</style>
